<script setup>
import dayjs from 'dayjs'
import { watch, ref } from 'vue'
import duration from 'dayjs/plugin/duration'
import { debounce } from 'lodash'

const props = defineProps({
  info: {
    type: Object,
    default: () => { },
  },
  onlyTime: {
    type: Boolean,
    default: () => false,
  },
  timeColor: {
    type: String,
    default: () => '',
  },
})

const emits = defineEmits(['end'])

dayjs.extend(duration)

let minutes = ref()
let seconds = ref()
let leftTime = ref()

// 两个数时间
function formatTime(time) {
  return time < 10 ? `0${time}` : time
}

// 赋值
function setTime(time) {
  minutes.value = ~~dayjs.duration(time * 1000).asMinutes()
  seconds.value = dayjs.duration(time * 1000).seconds()
}

let countDownInterval = null

/**
 * 倒计时
 * @param totalDuration - 秒
 */
function countdown(totalDuration) {
  if (countDownInterval) return
  let duration = totalDuration
  const startTime = new Date().getTime()
  let endTime = startTime
  let timeDifferance = 0 // 每1s倒计时偏差值，单位ms
  // let totalTimeDifferance = 0 // 总共倒计时偏差值，单位ms
  const interval = 1000
  setTime(duration)

  function countDown() {
    // 如果没有paperId 说明考试未开始
    if (!props.info.paperId) return

    duration = duration - 1
    leftTime.value = duration
    endTime = new Date().getTime()
    timeDifferance = endTime - startTime - (totalDuration - duration) * 1000
    let nextTime = interval - timeDifferance
    if (nextTime < 0) {
      nextTime = 0
    }

    if (duration <= 0) {
      // totalTimeDifferance = endTime - startTime - totalDuration * 1000
      clearTimeout(countDownInterval)
      emits('end')
    } else {
      countDownInterval = setTimeout(() => countDown(nextTime), nextTime)
    }
    setTime(duration)
  }

  countDownInterval = setTimeout(() => countDown(), interval)
}
setTime(props.info.leftTime || 0)
watch(
  () => props.info,
  debounce((e) => {
    if (typeof e.leftTime !== 'number') return
    leftTime.value = e.leftTime
    countdown(leftTime.value)
  }, 500),
  { deep: true, immediate: true },
)
</script>

<template>
  <div>
    <span v-if="leftTime >= 0" :class="leftTime < 300 ? 'text-[red]' : ''">
      <span v-if="!onlyTime">倒计时</span>
      <span class="font-mono">
        <span>{{ formatTime(minutes) || '00' }}:</span>
        <span>{{ formatTime(seconds) || '00' }}</span>
      </span>
    </span>
    <span v-else class="font-mono">00:00</span>
  </div>
</template>

<style lang="scss" scoped>
.border-bottom {
  @apply flex items-center justify-between pb-3;
  border-bottom: 1px solid #bdbdbd;
}
</style>
